<template>
  <TableLayout :permissions="['meihui:chatSession:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="用户ID"><el-input v-model="searchForm.userId" placeholder="用户ID" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar"><li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:chatSession:delete']">批量删除</el-button></li></ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="userId" label="用户ID" width="100" show-overflow-tooltip />
        <el-table-column prop="sessionId" label="会话ID" width="200" show-overflow-tooltip />
        <el-table-column prop="mode" label="模式" width="80" show-overflow-tooltip />
        <el-table-column prop="isActive" label="活跃" width="80" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{row}"><el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:chatSession:delete']">删除</el-button></template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'ChatSession', extends: BaseTable, components: { TableLayout, Pagination },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: 'AI会话', api: '/rentHouse/chatSession', 'field.id': 'id', 'field.main': 'id' })
    this.search()
  }
}
</script>